<template>
    <div>
        <div class="p_title container bottomline mt30">
            <div class="titlebox mt20">
                <h5>{{mainmenuitem.title}}</h5>
                <p>{{mainmenuitem.description}}</p>
            </div>
            <ul class="titlemenu mt50">
                <li v-for="(menu,index) in childmenus" :key="index" :class="pid == menu.id ? 'active' : '' ">
                    <a href="javascript:void(0)" @click="gotoinfo(menu)">{{menu.title}}</a>
                </li>
            </ul>
            <jobmenu :menuarray="childmenus" @gotoinfo="gotoinfo" :pid="pid"></jobmenu>
        </div>
        <div class="p_body container mt50">
            <div class="p_body_content">
                <div class="p_body_content_title">
                    <div class="p_ju_detail_headbox">
                        <div class="fleft">
                        <h5 class="fontbold">{{itemData.title}}</h5>
                        <span>{{itemData.resourse}}</span>
                        </div>
                        <div class="fright">发布日期：{{formatdata(itemData.createdTime)}}</div>
                    </div>
                    <div class="meta">
                        <i class="icon_calendar"></i> {{ (itemData.description && itemData.description.split('/').length>0) ? itemData.description.split('/')[0] : ''}}
                        <span>|</span> 
                        <i class="icon icofont-user-alt-3"></i> {{(itemData.description && itemData.description.split('/').length>0) ? itemData.description.split('/')[1] : ''}}
                        <span>|</span> 
                        <i class="icon_folder-alt"></i> {{ (itemData.description && itemData.description.split('/').length>0) ? itemData.description.split('/')[2] : ''}}
                
                    </div>
                </div>
                <div class="p_body_content_news mt50" v-html="itemData.content"></div>
            </div>
        </div>
    </div>
</template>



<script>

import util from '@/tools/js/util';
import configration from '@/tools/js/enumconfig'
import jobmenu from '../../components/jobmenu'

export default {
    data(){
        return {
            itemData:{},
            id:'',
            showtitle:'加入我们',
            imgbaseurl : this.$baseURL.fileurl,
            
            mainmenuitem:{},            //主显示分类
            childmenutree:[],   //  treemenu
            childmenus:[],
            fid:'',
            pid:''
        }
    },
     methods:{
        getData:function(id){
            let vm = this;
           
            vm.$httpi.get('/api/v1/articles/doc/getitem?id='+id)
            .then(function (response) {
                if(response != null && response.data.success){
                    vm.itemData = response.data.data;
                    vm.showtitle = vm.itemData.title;
                }
            });
        },
        initmenu(){
            let vm = this;

            if(vm.childmenutree == undefined || vm.childmenutree.length == 0) 
            { 
                vm.childmenutree = JSON.parse(localStorage.getItem(configration.config.enum.cache_menu))
            }

            vm.childmenus = [];
            if(vm.fid.length>0){
                //获取子菜单
                for(let i=0;i< vm.childmenutree.length;i++ ){
                    if(vm.childmenutree[i].id == vm.fid)
                    {
                        vm.mainmenuitem = vm.childmenutree[i];
                        vm.childmenus = vm.childmenutree[i].childs;
                        break;
                    }
                }
            }
        },

        formatdata:function(e){
            return util.formatDate.format(e,'yyyy-MM-dd')
        },
        gotoinfo(item){
            const vm = this;
            switch(item.code){
                case 'doc-joinus-social':
                case 'doc-joinus-shool':
                    vm.$router.push({path:'/job/find/list',query:{pid:item.id,fid:item.parentId}});
                    break;
                default:
                    vm.$router.push({path:'/job/info',query:{pid:item.id,fid:item.parentId}});
                                //vm.getData(item.id);
                    break;
            }
        },
        initpage(){
            let vm = this;
            //绑定
            if(vm.$route.query.pid!=undefined && vm.$route.query.pid.length>0)
            {
                vm.pid = vm.$route.query.pid;
            }
            if(vm.$route.query.fid!=undefined && vm.$route.query.fid.length>0)
            {
                vm.fid = vm.$route.query.fid;
            }
            if(vm.$route.query.id!=undefined && vm.$route.query.id.length>0)
            {
                vm.id = vm.$route.query.id;
                vm.getData(vm.$route.query.id);
            }
            vm.initmenu();
        }
     },
     mounted() {
        let vm = this;
        //绑定
        vm.initpage();
    },
    components: {
        jobmenu,
    }
}
</script>

